import "core-js/modules/es.array.push.js";
import { getChatInit, loadHistory, generateSessionId } from './api';
import { createChatWebSocket } from './ChatWebSocket';
export default {
  name: 'OnlineChat',
  data() {
    return {
      isOpen: false,
      inputText: '',
      messages: [],
      quickReplies: [],
      typing: false,
      connected: false,
      sessionId: '',
      ws: null
    };
  },
  mounted() {
    this.sessionId = generateSessionId();
    // 预加载快捷按钮数据,首次打开时无需等待
    getChatInit().then(data => {
      this.quickReplies = data && data.quickReplies || [];
    }).catch(() => {
      // 忽略初始化失败,真正打开聊天时再尝试
    });
  },
  beforeDestroy() {
    if (this.ws) {
      this.ws.close();
    }
  },
  methods: {
    openChat() {
      this.isOpen = true;
      this.$nextTick(() => this.scrollToBottom());
      // 每次打开都重新拉一次快捷按钮,避免管理员新增/删除后本地缓存与后端不一致
      this.refreshQuickReplies();
      if (!this.connected) {
        this.initChat();
      }
    },
    async refreshQuickReplies() {
      try {
        const data = await getChatInit();
        this.quickReplies = data && data.quickReplies || [];
      } catch (e) {
        // 静默失败,保留旧值
      }
    },
    closeChat() {
      this.isOpen = false;
    },
    initChat() {
      // 1. 加载历史消息 + 快捷按钮
      Promise.all([getChatInit(), loadHistory(this.sessionId)]).then(([initData, history]) => {
        this.quickReplies = initData && initData.quickReplies || [];
        if (history && history.length > 0) {
          this.messages = history;
        } else {
          this.messages.push({
            sender: 'ROBOT',
            content: initData && initData.welcome || '您好,请问有什么可以帮您?',
            timestamp: new Date().toISOString()
          });
        }
        this.$nextTick(() => this.scrollToBottom());
      }).catch(e => {
        console.error('加载聊天初始化数据失败', e);
      });

      // 2. 建立 WebSocket 连接
      this.connectWebSocket();
    },
    connectWebSocket() {
      this.ws = createChatWebSocket();
      this.ws.on('open', () => {
        this.connected = true;
      });
      this.ws.on('message', data => {
        if (!data) return;
        // 跳过回显的用户消息
        if (data.sender === 'USER') return;
        if (data.sender === 'ROBOT' || data.sender === 'SYSTEM' || data.sender === 'AGENT') {
          this.typing = false;
          this.messages.push({
            sender: data.sender,
            content: data.content,
            timestamp: data.timestamp || new Date().toISOString()
          });
          this.$nextTick(() => this.scrollToBottom());
          // 后端告知按钮失效时,重新拉一遍快捷按钮列表把死链清掉
          if (data.sender === 'SYSTEM' && data.content) {
            if (data.content.indexOf('已删除') >= 0 || data.content.indexOf('不可用') >= 0) {
              this.refreshQuickReplies();
            }
          }
        }
      });
      this.ws.on('close', () => {
        this.connected = false;
      });
      this.ws.on('error', () => {
        this.connected = false;
      });
      this.ws.connect().catch(e => {
        console.error('WebSocket 连接失败', e);
        this.connected = false;
      });
    },
    handleButtonClick(btn) {
      if (!this.connected) {
        this.$message && this.$message.warning('正在连接中,请稍后再试');
        return;
      }
      // 按钮点击不显示用户消息,仅触发后端流程
      this.typing = true;
      this.ws.send({
        type: 'BUTTON_CLICK',
        sessionId: this.sessionId,
        buttonId: btn.id
      });
    },
    handleSendText() {
      const text = (this.inputText || '').trim();
      if (!text || !this.connected) return;

      // 立即在 UI 上显示用户消息
      this.messages.push({
        sender: 'USER',
        content: text,
        timestamp: new Date().toISOString()
      });
      this.typing = true;
      this.inputText = '';
      this.$nextTick(() => this.scrollToBottom());
      this.ws.send({
        type: 'TEXT',
        sessionId: this.sessionId,
        content: text
      });
    },
    scrollToBottom() {
      const el = this.$refs.messageListRef;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    },
    formatMessage(text) {
      if (!text) return '';
      // 简单 XSS 防护 + 换行
      return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br/>');
    },
    formatTime(timestamp) {
      if (!timestamp) return '';
      const d = new Date(timestamp);
      if (isNaN(d.getTime())) return '';
      const pad = n => String(n).padStart(2, '0');
      return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }
  }
};